<template>
  <div>
    <hr v-if="subType !== 'voucher_fuel'">
    <div class="row" v-if="subType !== 'voucher_fuel'">
      <div class="col-6 col-md-6 form-group" >
        <span id="threshold_description"
              class="d-inline-block flexben-tooltip-icon ml-2 mr-2 text-bold">i</span>
        <b-tooltip :target="'threshold_description'" variant="flexben" placement="topleft">
          <div class="text-left">{{$t('flexben.benefit.thresholds.tooltip', {value:'gym_membership'})}}</div>
        </b-tooltip>

        <label  for="threshold" class="form-fields-required text-bold mb-0 mr-4 col-form-label p-0">
          {{ $t('flexben.benefit.thresholds.' + 'gym_membership') }}</label>

        <b-form-checkbox id="threshold" class="float-right"
                         @change="$emit('addThreshold', 'gym_membership', gymMembership)"
                         v-model="gymMembership"
                         :disabled="disabled"
                         switch></b-form-checkbox>
      </div>
    </div>
    <div class="row" v-if="subType !== 'voucher_fuel' && !forCampaign">
      <div class="col-6 col-md-6 form-group">
        <label for="mark_as_sport_voucher" class="form-fields-required text-bold mb-0 mr-4 col-form-label p-0">
          {{ $t('flexben.benefit.fields.mark_as_sport_voucher') }}
        </label>

        <b-form-checkbox id="mark_as_sport_voucher" class="float-right"
                         v-model="fields.mark_as_sport_voucher"
                         :disabled="disabled"
                         switch></b-form-checkbox>
      </div>
    </div>
    <div class="row" v-if="subType !== 'voucher_fuel'">
      <div class="col-6 col-md-6 form-group" >
        <span id="for_campaign_tool_tip"
              class="d-inline-block flexben-tooltip-icon ml-2 mr-2 text-bold">i</span>
        <b-tooltip :target="'for_campaign_tool_tip'" variant="flexben" placement="topleft">
          <div class="text-left">{{ $t('flexben.benefit.fields.for_campaign_info') }}</div>
        </b-tooltip>

        <label  for="for_campaign" class="form-fields-required text-bold mb-0 mr-4 col-form-label p-0">
          {{ $t('flexben.benefit.fields.for_campaign') }}</label>

        <b-form-checkbox id="for_campaign" class="float-right"
                         v-model="forCampaign"
                         switch></b-form-checkbox>
      </div>
    </div>
    <div class="row" v-if="forCampaign">
      <div class="col-12 text-danger mb-2">{{ $t('flexben.benefit.fields.for_campaign_info') }}</div>
      <div class="col-12 col-md-6 form-group">
        <label class="col-form-label form-fields-required" for="campaign_partner">
          {{ $t('flexben.benefit.fields.for_campaign_partner') }}
        </label>

        <multiselect
            id="campaign_partner"
            name="partner"
            v-model="selectedCampaignPartner"
            :options="campaignPartners"
            label="name"
            track-by="id"
            :multiple="false"
            :searchable="true"
            :close-on-select="true"
            :clear-on-select="false"
            :placeholder="$t('flexben.benefit.fields.for_campaign_partner_placeholder')"
            :show-labels="false"
        />
      </div>
      <div class="col-12 col-md-6 form-group">
        <label class="col-form-label form-fields-required" for="campaign_brand">
          {{ $t('flexben.benefit.fields.for_campaign_brand') }}
        </label>

        <multiselect
            id="campaign_brand"
            name="brand"
            v-model="selectedCampaignBrand"
            :options="campaignBrands"
            label="name"
            track-by="id"
            :multiple="false"
            :searchable="true"
            :close-on-select="true"
            :clear-on-select="false"
            :placeholder="$t('flexben.benefit.fields.for_campaign_brand_placeholder')"
            :show-labels="false"
        />
      </div>
    </div>
    <hr>
    <div class="row">
      <div class="col-12 col-md-6 form-group">
        <label for="delivery_type" class="form-fields-required col-form-label">
          {{ $t('flexben.benefit.fields.delivery_type') }}</label>
        <select class="form-control" id="delivery_type" v-model="fields.delivery_type"
                @change="clearVoucherValue()"
                :disabled="disabled"
                :class="{'border-danger':(Object.keys(errorsBag).includes('delivery_type'))}">
          <option :value="null">-</option>
          <option v-for="(type, index) in deliveryTypes"
                  :value="type"
                  :key="index">{{ $t('flexben.benefit.delivery_types.'+type) }}
          </option>
        </select>
      </div>

      <div class="col-12 col-md-6 form-group"
           v-show="fields.delivery_type!==null && fields.delivery_type!=='card'">
        <label for="voucher_value" class="form-fields-required col-form-label">
          {{ $t('flexben.benefit.fields.voucher_billing_value') }}</label>
        <input type="number" id="voucher_value" v-model="fields.billing_value" class="form-control"
               :disabled="disabled"
               :class="{'border-danger':(Object.keys(errorsBag).includes('voucher_billing_value'))}"/>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-md-6 form-group">
        <label for="discount_type" class="form-fields-required col-form-label">
          {{ $t('flexben.benefit.fields.discount.type') }}</label>
        <select class="form-control" id="discount_type" v-model="discountData.discount_type"
                :disabled="disabled"
                :class="{'border-danger':(Object.keys(errorsBag).includes('discount_types'))}">
          <option :value="null">-</option>
          <option v-for="(type, index) in discountTypes"
                  :value="type.value"
                  :key="index">{{ type.name }}
          </option>
        </select>
      </div>
      <div class="col-12 col-md-6 form-group"
           v-show="discountData.discount_type">
        <label for="discount_value" class="form-fields-required col-form-label">
          {{ $t('flexben.benefit.fields.discount.value') }}</label>
        <label for="discount_value" class="form-fields-required col-form-label text-danger">
          {{ $t('flexben.discount.info.total_value') }}</label>
        <input type="number" step="0.1" id="voucher_value" v-model="discountData.discount_value" class="form-control"
               :disabled="disabled"
               :class="{'border-danger':(Object.keys(errorsBag).includes('discount_value'))}"/>
      </div>
      <div class="col-12 col-md-6 form-group"
           v-show="discountData.discount_type">
        <ul>
          <li>
            Discount: {{ discountData.discount_value }}
            {{ (discountData.discount_type === 1) ? '%' : 'RON' }}
          </li>

          <li v-if="discountData.discount_type === 1">
            Discounted Price: {{ fields.billing_value * (1 - discountData.discount_value / 100) }} RON
          </li>
          <li v-else>
            Discounted Price: {{ fields.billing_value - discountData.discount_value }} RON
          </li>
        </ul>
      </div>
    </div>
  </div>

</template>

<script>
import {BFormCheckbox, BTooltip} from "bootstrap-vue";
import Multiselect from "vue-multiselect";

export default {
  name: "BenefitVoucherFormFields",
  components: {
    'b-tooltip': BTooltip,
    "b-form-checkbox": BFormCheckbox,
    Multiselect

  },
  props: {
    for_campaign: {
      type: Boolean,
      default: false,
    },
    subType: {
      type: String,
      required: true
    },
    fields: {
      type: Object,
      default: function () {
        return {};
      },
      required: true
    },
    options: {
      type: Object,
      default: function () {
        return {};
      },
      required: true
    },
    partner_id: {
      default: null,
    },
    brand_availability: {
      default: null,
    },
    deliveryTypes: {
      type: Array,
      required: true,
      default: function () {
        return []
      },
    },
    discountTypes: {
      type: Array,
      required: true,
      default: function () {
        return []
      },
    },
    discountData: {
      type: Object,
      required: true
    },
    errorsBag: {
      type: Object,
      default: function () {
        return {};
      },
      required: true
    },
    voucherValueUrl: {
      default: null,
    },
    formAction: {
      required: true,
      type: String
    },
    benefitStatus: {
      required: true,
      type: String
    },
    disabled: {
      type: Boolean,
      default: false
    },
  },
  data: function () {
    return {
      gymMembership: false,


    };
  },
  computed: {
    forCampaign: {
      get() {
        return this.for_campaign;
      },
      set(value) {
        if (value) {
          this.fields.mark_as_sport_voucher = false;
        }
        this.$emit('update:for_campaign', value);
      }
    },
    campaignPartners() {
      return this.options.for_campaign && this.options.for_campaign.partners
        ? this.options.for_campaign.partners
        : [];
    },
    campaignBrands() {
      return this.options.for_campaign && this.options.for_campaign.brands
        ? this.options.for_campaign.brands
        : [];
    },
    selectedCampaignPartner: {
      get() {
        if (this.partner_id === null || this.partner_id === undefined || !this.campaignPartners.length) {
          return null;
        }

        return this.campaignPartners.find(partner => {
          return Number(partner.id) === Number(this.partner_id);
        }) || null;
      },
      set(value) {
        this.$emit('update:partner_id', value ? value.id : null);
      }
    },
    selectedCampaignBrand: {
      get() {
        if (this.brand_availability === null || this.brand_availability === undefined || !this.campaignBrands.length) {
          return null;
        }

        return this.campaignBrands.find(brand => {
          return Number(brand.id) === Number(this.brand_availability);
        }) || null;
      },
      set(value) {
        this.$emit('update:brand_availability', value ? value.id : null);
      }
    }
  },


  created() {
    this.gymMembership = this.getGymMembership();
    console.log(this.fields);
  },
  methods: {
    creatDiscountData() {
      // this.discountData.discount_type = this.fields.discount_type;

    },
    clearVoucherValue() {
      if (this.disabled) {
        return;
      }

      this.fields.billing_value = 0;
    },
    getGymMembership() {
      if (!this.fields.thresholds.length) {
        return false;
      }

      return this.fields.thresholds.find(function (item) {return item.name === 'gym_membership'}) ?
        this.fields.thresholds.find(function (item) {return item.name === 'gym_membership'})['value'] : false
    }
  }
}
</script>
<style scoped>
.flexben-tooltip-icon {
  font-family: "Times New Roman", sans-serif;
  color: #dc3545;
  border: 1px solid gray;
  background-color: #fff;
  font-size: 16px;
  font-weight: bold;
  border-radius: 50%;
  width: 22px;
  height: 22px;
  text-align: center;
  cursor: pointer;
  line-height: initial;
}
</style>
